var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data"},[(_vm.mode === 'image')?_c('img',{staticClass:"no-data__img",attrs:{"src":require("@/assets/img/search/no-search-img.png")}}):_vm._e(),_c('p',{staticClass:"no-data__text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }